module.exports = __webpack_public_path__ + "static/media/bolso (36).0a126e92.jpg";